
<!-- @if(isCopied) {
  <span
    class="material-symbols-outlined cursor-pointer text-base text-primary-500 bg-red-200"
    [tooltipPosition]="tooltipPosition ? tooltipPosition : 'left'"
    [pTooltip]="isCopied ? 'copied' : ('copy ' + (title ? title : ''))"
    >
    check
  </span>
} @else {
  <span
    class="material-symbols-outlined cursor-pointer text-base hover:text-primary-500 bg-red-200"
    (click)="handleClick()"
    [tooltipPosition]="tooltipPosition ? tooltipPosition : 'left'"
    [pTooltip]="isCopied ? 'copied' : ('copy ' + (title ? title : ''))"
    >
    {{isCopied ? 'check' : 'file_copy' }}
  </span>
} -->

<span
  class="material-symbols-outlined cursor-pointer text-base"
  (click)="$event.stopImmediatePropagation();handleClick()"
  [tooltipPosition]="tooltipPosition ? tooltipPosition : 'left'"
  [pTooltip]="isCopied ? 'Copied' : ('Copy ' + (title ? title : ''))"
  >
  @if (isCopied){
    <i class="pi pi-check" [style.fontSize]=" size ? size : '0.9rem'"></i>
  }@else {
    <i class="pi pi-copy" [style.fontSize]="size ? size : '0.9rem'"></i>
  }
</span>
